import { useEffect } from "react";

export function useMenuScrollLock() {
    useEffect(() => {
        const target = document.body; // observe body for class changes
        if (!target) return;

        const observer = new MutationObserver(() => {
            const activeMenu = document.querySelector(".menu-hider.menu-active");

            if (activeMenu) {
                document.documentElement.style.overflow = "hidden";
            } else {
                document.documentElement.style.overflow = "";
            }
        });

        observer.observe(target, {
            attributes: true,
            subtree: true,
            attributeFilter: ["class"],
        });

        return () => {
            observer.disconnect();
            document.documentElement.style.overflow = "";
        };
    }, []);
}
